module.exports = __webpack_public_path__ + "static/img/1-title.59ae3df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/1-title.png
// module id = dyPi
// module chunks = 0